var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashRedIcon = function SvgTrashRedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA1E28",
    d: "M20.25 4.5h-3.375V3.375A2.625 2.625 0 0 0 14.25.75h-4.5a2.625 2.625 0 0 0-2.625 2.625V4.5H3.75a1.125 1.125 0 0 0 0 2.25h.375V19.5A1.875 1.875 0 0 0 6 21.375h12a1.875 1.875 0 0 0 1.875-1.875V6.75h.375a1.125 1.125 0 0 0 0-2.25M9.375 3.375A.375.375 0 0 1 9.75 3h4.5a.375.375 0 0 1 .375.375V4.5h-5.25zm8.25 15.75H6.375V6.75h11.25zm-6.75-9.375v6a1.125 1.125 0 1 1-2.25 0v-6a1.125 1.125 0 0 1 2.25 0m4.5 0v6a1.125 1.125 0 1 1-2.25 0v-6a1.125 1.125 0 1 1 2.25 0"
  })));
};
export default SvgTrashRedIcon;